import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Search, CornerDownLeft } from "lucide-react";

const CommandPalette = ({
  open,
  onClose,
  query,
  setQuery,
  commands,
  selectedIndex,
  onSelect,
}) => {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.15 }}
          className="fixed inset-0 z-[9999] bg-black/50 backdrop-blur-sm flex justify-center pt-28 px-4"
          onClick={onClose}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.96, y: -8 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.97, y: -8 }}
            transition={{ type: "spring", stiffness: 380, damping: 28 }}
            onClick={(e) => e.stopPropagation()}
            className="relative glass-sheen w-full max-w-xl h-fit rounded-3xl glass-strong shadow-e3 overflow-hidden"
          >
            <div className="flex items-center gap-3 px-5 border-b hairline">
              <Search className="w-4 h-4 text-slate-400 shrink-0" />
              <input
                autoFocus
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="Type a command..."
                className="w-full bg-transparent py-4 text-white placeholder-slate-500 outline-none"
              />
              <kbd className="hidden sm:block text-[10px] font-medium text-slate-500 border border-white/10 rounded px-1.5 py-0.5">
                ESC
              </kbd>
            </div>

            <div className="max-h-80 overflow-y-auto scrollbar-transparent p-2">
              {commands.length === 0 ? (
                <p className="text-center text-sm text-slate-500 py-6">
                  No matching commands
                </p>
              ) : (
                commands.map((cmd, index) => (
                  <button
                    key={cmd.label}
                    onClick={() => onSelect(cmd)}
                    className={`w-full flex items-center justify-between gap-3 text-left px-4 py-2.5 rounded-xl transition-colors ${
                      index === selectedIndex
                        ? "bg-accent-400/12 text-white"
                        : "text-slate-300 hover:bg-white/[0.05]"
                    }`}
                  >
                    <span className="text-sm font-medium">{cmd.label}</span>
                    {index === selectedIndex && (
                      <CornerDownLeft className="w-3.5 h-3.5 text-accent-300" />
                    )}
                  </button>
                ))
              )}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CommandPalette;
